/**
 * LibSection — `.lib-section` from the prototype (cms-redesign-mockup.html
 * ~line 1724–1752). Used on list pages that group items into multiple
 * homogeneous sections (Categories: Audio / Quick Tap / Audiobook).
 *
 *   <LibSection title="Audio Categories" count={48} hint="Drag to reorder">
 *     <LibTable>…</LibTable>
 *   </LibSection>
 *
 * Section head structure (`.lib-section-head` 1731–1752):
 *   • h2 — Asap Condensed-ish 18px / 700 navy
 *   • Optional count chip — JetBrains Mono 11px text-muted on cream pill
 *   • Optional hint — right-aligned 12px text-muted ("Drag any row to reorder")
 *   • 1px sand bottom-border with 8px gap to the body
 */
import React from 'react';
import { cn } from './cn';

export default function LibSection({ title, count, hint, children, className, first = false }) {
  return (
    <section
      className={cn(className)}
      style={{ marginTop: first ? 16 : 22 }}
    >
      <header
        className="flex items-baseline border-b border-sand"
        style={{ gap: 10, marginBottom: 10, paddingBottom: 8 }}
      >
        <h2
          className="font-bold text-navy"
          style={{ fontSize: 18, margin: 0 }}
        >
          {title}
        </h2>
        {count != null && (
          // `.lib-section-count` — JetBrains Mono 11/cream-bg/sand-border pill.
          <span
            className="font-mono text-text-muted bg-cream border border-sand inline-flex items-center"
            style={{
              fontSize: 11,
              padding: '2px 9px',
              borderRadius: 999,
            }}
          >
            {typeof count === 'number' ? count.toLocaleString() : count}
          </span>
        )}
        {hint && (
          // `.lib-section-hint` — pushed right via ml-auto, 12px text-muted.
          <span
            className="ml-auto text-text-muted"
            style={{ fontSize: 12 }}
          >
            {hint}
          </span>
        )}
      </header>
      {children}
    </section>
  );
}
